import React from 'react';
import './CredibilitySection.css';

const CredibilitySection = () => {
  const institutions = [
    { name: 'Institution 1', logo: '🏛️' },
    { name: 'Institution 2', logo: '🎓' },
    { name: 'Institution 3', logo: '🏫' },
    { name: 'Institution 4', logo: '📚' }
  ];

  return (
    <section className="section credibility-section">
      <div className="container">
        <h2 className="section-title">Credibility & Experience</h2>

        <div className="credibility-content">
          <div className="stats-container">
            <div className="stat-item">
              <span className="stat-number">10+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">50,000+</span>
              <span className="stat-label">Students Mentored</span>
            </div>
          </div>

          <div className="institutions-container">
            <h3 className="institutions-title">Collaborating Institutions</h3>
            <div className="institutions-logos">
              {institutions.map((inst, index) => (
                <div key={index} className="institution-logo">
                  <div className="logo-placeholder">
                    <span>{inst.logo}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredibilitySection;
